import { ITemplateFormData } from '../models';

export function isQuestionFormValid(data: Partial<ITemplateFormData>) {
	const { questions } = data;
	return (
		questions?.length && questions.every(({ error, text }) => !error && !!text)
	);
}
